import React from "react";

class Blog extends React.Component {
  render() {
    return (
      <div class="container d-flex h-100">
        <div class="align-self-center w-100 row">
          <div class ="col-lg-3 col-md-12 offset-lg-3" style = {{textAlign: 'left'}}>
            <h1 class = 'blog-moving-title'>Our Medium Posts</h1>
            <hr/>
            <p class = 'blog-paragraph'>See more on our Medium Blog <a href ='' class = 'blog-link'>here</a></p>
          </div>
          <div class ="col-lg-3 col-md-6">
            <div class = 'blog-background'>
              <p class = 'jobs-paragraph'>
              <div style = {{height:'5px', width: '30px', backgroundColor:'#e0df87'}} />
                <a href = 'https://medium.com/@gofurbrente01/revolusi-mobile-development-dengan-flutter-google-d6b9a5c34fc5'><h4 class = 'community-title-modifier article-title'>Revolusi Mobile Development dengan Flutter</h4>
                </a><br/>
                <span class = 'blog-author'>ABDUL GHAPUR</span><br/>
                <span class = 'blog-date'> May 4, 2018 </span> • <span class = 'blog-length'>2 min read</span>
                <br/>
              </p>
            </div>
          </div>
          <div class ="col-lg-3 col-md-6">
            <div class = 'blog-background'>
              <p class = 'jobs-paragraph'>
              <div style = {{height:'5px', width: '30px', backgroundColor:'#e0df87'}} />
                <h4 class = 'community-title-modifier article-title'>Battle Scars: How to Survive the Talent War in Jakarta's Startup Industry</h4>
                <br/>
                <span class = 'blog-author'>ADYA DANADITYA</span><br/>
                <span class = 'blog-date'> June 30, 2018 </span> • <span class = 'blog-length'>2 min read</span>
                <br/>
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/components/Blog.js